var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.iterate),function(n,index){return _c('div',{key:`Placeholder ${n}`,staticClass:"placeholder",style:({ 'animation-delay': `${index * 0.1}s` })},[_c('i',{class:_vm.Icon.User})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }